export const PANEL_ID = {
  ANALYTICS: 'analytics',
  APPLICATIONS: 'applications',
  FIND_TENANTS: 'findTenants',
  LEASES: 'leases',
  MANAGE_TENANTS: 'manageTenants',
  MESSAGES: 'messages',
  PAYMENTS: 'payments',
  REVIEWS: 'reviews',
  // ZRM-PMS
  OVERVIEW: 'overview',
  EDIT_LISTING: 'editListing',
  LIST: 'list',
  MANAGE_PERMISSIONS: 'managePermissions',
  RELEASE_CLAIM: 'releaseClaim',
};

export const escapeRoute = (id: string) => {
  switch (id) {
    // within rmw
    case PANEL_ID.ANALYTICS:
    case PANEL_ID.FIND_TENANTS:
    case PANEL_ID.MANAGE_TENANTS:
    case PANEL_ID.REVIEWS:
    case PANEL_ID.OVERVIEW:
    case PANEL_ID.EDIT_LISTING:
    case PANEL_ID.LIST:
      return false;

    // outside of rmw
    // fall through
    case PANEL_ID.APPLICATIONS:
    case PANEL_ID.LEASES:
    case PANEL_ID.PAYMENTS:
    case PANEL_ID.MESSAGES:
    default:
      return true;
  }
};

export default escapeRoute;
